<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled"
                 ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class=" p-3 max-h-64 overflow-y-auto w-full z-30 text-xs">
                <div class="space-y-6">
                    <div v-if="results.length > 0">
                        <div class="flex text-xs font-medium text-gray-400 mb-1">
                            <div class="ml-2 flex-grow">Resource Planning Report Item</div>
                            <div class="flex-shrink mr-4">
                                <div
                                    class="px-2 border border-red-200 rounded text-xs w-full text-left font-medium bg-red-50 text-red-500 focus:outline-none hover:bg-red-100 cursor-pointer"
                                    @click="selectItem(null,null,null,close)"
                                >
                                    <span class="fas fa-times mr-1"></span>Clear
                                </div>
                            </div>
                        </div>
                        <div class="space-y-1">
                            <div
                                v-for="section in results"
                                class="flex space-x-2 text-left w-full text-gray-500 pl-2 pr-1 py-0"
                                :title="section.name"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full py-1" v-text="section.name"></div>
                                    <div
                                        v-for="task in section.tasks"
                                        class="flex space-x-2 text-left w-full pl-2 pr-1 py-0"
                                        :title="task.reference+' - '+task.name"
                                    >
                                        <div class="truncate flex-1 flex flex-col">
                                            <div class="truncate w-full py-1"
                                                 v-text="task.reference+' - '+task.name"></div>
                                            <div
                                                v-for="item in task.items"
                                                class="flex space-x-2 text-left w-full pl-2 pr-1 py-0"
                                                :title="item.reference+' - '+item.name"
                                            >
                                                <div class="truncate flex-1 flex flex-col text-blue-500">
                                                    <div class="truncate w-full">
                                                        <div class="truncate text-sms mx-0 py-0.5 px-1">
                                                            <button
                                                                @mousedown="selectItem(section,task,item, close)"
                                                                class="flex truncate px-1 py-1.5 -my-0.5 border border-transparent rounded-lg text-xs w-full text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600"
                                                            >
                                                <span class="flex-1 flex flex-grow mx-1 relative truncate">
                                                    <span class="flex-grow truncate"
                                                          v-text="item.reference+' - '+item.name">
                                                    </span>
                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="(results.length ===0)" class="text-gray-500 text-sm">
                        No items found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import {ProjectDeliveryRequestForMaterials as RequestForMaterials} from "@models";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";

export default {
    components: {UiButtonNew, UiDropdown},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        enabled: true,
        requestForMaterials: RequestForMaterials,
        requestForMaterialItem: Object,
        resourcePlanningReport: Object,
    },
    data() {
        return {
            results: [],
        }
    },
    watch: {
        "RequestForMaterials.packageReference": {
            handler(newValue, oldValue) {
                this.buildTree()
            },
        },
    },
    computed: {},
    methods: {
        scope(dropdownScope) {
            return {
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        buildTree() {
            let tree = [];
            let addToTree = (section, task, item) => {
                let s = tree.find((i) => i.id === section.id);
                if (!s) {
                    s = {id: section.id, name: section.name, tasks: []}
                    tree.push(s);
                }
                let t = s.tasks.find((i) => i.id === task.id);
                if (!t) {
                    t = {id: task.id, name: task.name, reference: task.reference, items: []}
                    s.tasks.push(t);
                }
                let i = t.items.find((i) => i.id === item.id);
                if (!i) {
                    i = {id: item.id, name: item.description, reference: item.reference, materials: []}
                    t.items.push(i);
                }
            }
            if (this.resourcePlanningReport) {
                this.resourcePlanningReport.sections.filter((i) => !i.omitted).forEach(section => {
                    section.tasks.filter((i) => !i.omitted).forEach(task => {
                        task.items.filter((i) => !i.omitted).forEach(item => {
                            addToTree(section, task, item);
                        })
                    })
                })
            }
            this.results = tree;
        },
        async setQuery(query, open = true) {
            this.buildTree()
            if (open) {
                this.$refs.dropdown.close();
                this.$refs.dropdown.open();
            }
        },
        async selectItem(section, task, item, close) {
            this.$emit('selected:item', section, task, item);
            close();
        },
        clear(close) {
            close();
        },
        close() {
            this.$refs.dropdown.close();
        },
    },
    async mounted() {
        this.buildTree()
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
